<template>
    <list-page icone="mdi-calendar-remove" titulo="Fechamento do Mês" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" tipoInput='number'>
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1" :sort-by="['ano', 'mes']" :sort-desc="[true, true]" multi-sort>
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.ano }}</td>
                    <td>{{ item.mes }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <cadastro-fechamentomes v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import FechamentoMesService from '@/core/services/financeiro/FechamentoMesService';
import FechamentoMes from '@/core/domain/financeiro/FechamentoMes';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Ano', value: 'ano', type: 'number' },
        { text: 'Mês', value: 'mes', type: 'number' }
      ],
    }),
    created() {
      this.service = new FechamentoMesService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new FechamentoMes());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new FechamentoMes(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>
<style scoped>

</style>
